import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Modal } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  CREATED,
  OptimizationProcessStatus,
  RUNNING,
  STOPPING,
} from '../../../types/optimizationProcesses'
import { useDeleteOptimizationProcess } from './useDeleteOptimizationProcess'

export const DeleteButton = ({
  optimizationProcessId,
  status,
}: {
  optimizationProcessId: number
  status: OptimizationProcessStatus
}) => {
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false)
  const { t } = useTranslation()
  const { mutate: deleteOptimizationProcess, isLoading } =
    useDeleteOptimizationProcess()

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setDeleteConfirmModal(true)
  }

  const handleDeleteConfirm = () => {
    deleteOptimizationProcess(optimizationProcessId)
    setDeleteConfirmModal(false)
  }

  const isDisabled =
    status === CREATED || status === RUNNING || status === STOPPING

  return (
    <>
      <Button
        icon={<FontAwesomeIcon icon={faTrash} />}
        onClick={handleDeleteClick}
        title={t('Delete')}
        label=""
        buttonType="button"
        type="blank-action"
        size="md"
        disabled={isDisabled}
      />
      {deleteConfirmModal && (
        <Modal
          title={t('Confirm Delete')}
          onCloseRequest={() => setDeleteConfirmModal(false)}
          footer={
            <>
              <Button
                buttonType="button"
                label={t('Cancel')}
                onClick={() => setDeleteConfirmModal(false)}
              />
              <Button
                label={t('Delete')}
                type="action"
                onClick={handleDeleteConfirm}
                loading={isLoading}
                disabled={isLoading}
              />
            </>
          }
        >
          <p>
            {t('Are you sure you want to delete this optimization process?', {
              id: optimizationProcessId,
            })}
          </p>
        </Modal>
      )}
    </>
  )
}
